/// <reference path="skyward.ui.window.js"/>
/// <reference path="skyward.ui.modallayer.js"/>
(
    function (skyward, $, undefined)
    {
        "use strict";

        skyward.eel = skyward.eel || {};

        var getDefaultCodeEELOptions = function ()
        {
            return {
                userInputs: [],
                getSelectionListContainer: function () { },
                getSelectionList: function (includeSubsequentRecords) { },
                selectionListPositioningOptions: {},
                setCurrentEnteredValue: function (/* input */) { },
                setCurrentHighlightedValue: function () { },
                clearValues: function () { },
                alwaysExpose: [],
                beforeClose: function () { },
                beforeOpen: function () { },
                onSelectionListLoad: function () { }
            };
        };

        var showEELContainer = ".js-showEELContainer";

        var defaultUserInput =
        {
            input: null,
            button: null,
            customKeyDownHandler: function (/* event */) { /* Handle custom keydown events not already handled by this code */ }
        };

        skyward.eel.setFocusToTextBoxOnClick = function (eel)
        {
            eel.find(".eELInputContainer").on('click', function ()
            {
                const textbox = $(this).find(".eELInputContainer__textBox");
                // Use native focus() to work around a bug in JQuery - likely 4950 or 4867
                // TODO (jquery 3.6.x) see if this is still needed
                if (textbox.length > 0)
                {
                    textbox[0].focus();
                }
            });
        };

        skyward.eel.createEel = function (options)
        {
            var eel = {};
            var defaultCodeEELOptions = getDefaultCodeEELOptions();
            var settings = $.extend({}, defaultCodeEELOptions, options);
            var modalLayer;
            var eelValueListContainer;
            var userIsChangingValue = false;
            var userSelectedValue = true;

            var beforeClose = function ()
            {
                if (!userSelectedValue)
                {
                    settings.clearValues();
                }

                eelValueList.hide();
                eelGlass.hide(true);
                userIsChangingValue = false;
                userSelectedValue = true;

                settings.beforeClose();
            };

            var eelGlass = (function ()
            {
                var eelGlass = {};
                var glassIsShowing = false;

                eelGlass.isShowing = function ()
                {
                    return glassIsShowing;
                };

                eelGlass.hide = function (isClosing)
                {
                    if (glassIsShowing && !isClosing)
                    {
                        modalLayer.close();
                    }

                    glassIsShowing = false;
                };

                eelGlass.show = function (input)
                {
                    if (!glassIsShowing)
                    {
                        eelValueListContainer = settings.getSelectionListContainer();
                        modalLayer = skyward.modalLayer.newModalLayer(eelValueListContainer, beforeClose,
                            {
                                expose: settings.alwaysExpose.concat([input])
                            });
                    }

                    glassIsShowing = true;
                };

                return eelGlass;
            })();

            var eelValueList = (function ()
            {
                var eelValueList = {};
                var eelValueListIsShowing = false;

                eelValueList.isShowing = function ()
                {
                    return eelValueListIsShowing;
                };

                eelValueList.hide = function ()
                {
                    if (!eelGlass.isShowing())
                    {
                        return;
                    }

                    eelValueListContainer.hide();
                    eelValueListContainer.html('');
                    eelValueListIsShowing = false;
                };

                eelValueList.show = function (input, containerToExpose, includeSubsequentRecords)
                {
                    if (userSelectedValue)
                    {
                        return;
                    }
                    settings.beforeOpen();

                    eelGlass.show(containerToExpose);

                    $.when(settings.getSelectionList(includeSubsequentRecords)).done(function (contents)
                    {
                        if (!eelGlass.isShowing() || userSelectedValue)
                        {
                            return;
                        }

                        // Use native focus() to work around a bug in JQuery - likely 4950 or 4867
                        // TODO (jquery 3.6.x) see if this is still needed
                        if (input.length > 0)
                        {
                            input[0].focus();
                        }
                        eelValueListContainer.html(contents);
                        eelValueListContainer.show();
                        eelValueListIsShowing = true;

                        var positioningManager = skyward.modalLayer.createModalPositioningManager(modalLayer, containerToExpose, modalLayer.contents, settings.selectionListPositioningOptions);
                        modalLayer.options.resizeCallback = positioningManager.positionEELContents;

                        if (modalLayer.options.resizeCallback && typeof modalLayer.options.resizeCallback === 'function')
                        {
                            // callback is unregistered in modallayer.js:1657
                            skyward.window.registerLayoutResizeCallback(modalLayer.options.resizeCallback);
                            modalLayer.options.resizeCallback();
                        }

                        settings.onSelectionListLoad();
                    }).fail(function ()
                    {
                        eelGlass.hide();
                    });
                };

                return eelValueList;
            })();

            var selectCurrentEnteredValue = function (input)
            {
                userSelectedValue = true;
                settings.setCurrentEnteredValue(input);
                eelGlass.hide();
            };

            eel.selectCurrentHighlightedValue = function ()
            {
                userSelectedValue = true;
                settings.setCurrentHighlightedValue();
                eelGlass.hide();
            };

            eel.showSelectionList = function (input)
            {
                userSelectedValue = false;
                eelValueList.show(input, input.closest(showEELContainer), false);
            };

            eel.hideSelectionList = function ()
            {
                eelValueList.hide();
                eelGlass.hide(false);
            };

            var acceptInput = function (input, lastValue)
            {
                if (input.is("[disabled],[readonly],.ui-disabled"))
                {
                    return false;
                }

                return true;
            };

            $.each(settings.userInputs, function (i, userInputOptions)
            {
                var userInputSettings = $.extend({}, defaultUserInput, userInputOptions);
                var input = userInputSettings.input;
                var button = userInputSettings.button;
                var lastValue = input.val().toLowerCase();

                input.on("input", function ()
                {
                    var input = $(this);

                    if (acceptInput(input, lastValue))
                    {
                        userIsChangingValue = true;
                        userSelectedValue = false;
                        eelValueList.hide();
                    }
                });

                input.debounce("input", function ()
                {
                    var input = $(this);

                    if (acceptInput(input, lastValue))
                    {
                        eelValueList.show(input, input.closest(showEELContainer));
                        lastValue = input.val().toLowerCase();
                    }
                });

                input.on("keydown", function (event)
                {
                    var input = $(this);

                    if (!acceptInput(input, null))
                    {
                        return;
                    }

                    if (!eelGlass.isShowing() && !userIsChangingValue && (event.which === 39 || event.which === 40 || event.which === 13)) // if down, right or enter
                    {
                        userSelectedValue = false;
                        eelValueList.show(input, input.closest(showEELContainer), true);
                    }
                    else if (!eelValueList.isShowing() && userIsChangingValue && (event.which === 9 || event.which === 13)) // if tab or enter
                    {
                        selectCurrentEnteredValue(input);
                    }
                    else if (eelValueList.isShowing() && (event.which === 9 || event.which === 13))
                    {
                        eel.selectCurrentHighlightedValue();
                    }
                    else
                    {
                        userInputSettings.customKeyDownHandler.apply(this, arguments);
                    }
                });

                button.on("click", function ()
                {
                    if (modalLayer == null || !modalLayer.onscreen)
                    {
                        var button = $(this);
                        var input = $(userInputSettings.input);

                        if (button.hasClass("ui-disabled") || !acceptInput(input))
                        {
                            return;
                        }

                        userSelectedValue = false;
                        eelValueList.show(input, input.closest(showEELContainer), true);
                    }
                    else if (!skyward.global.mobileAccess)
                    {
                        modalLayer.close();
                        return;
                    }
                });
            });

            return eel;
        };

    }(window.skyward = window.skyward || {}, window.jQuery)
);
